var YT, ytPlayer, quoteRun, slideRun, quoteDelay = 5, slideDelay = 5, sDur = 1, qP = 1, pP = 0, sP = 1, qDir = 'R', sDir = 'R';

$(document).ready(function(){

	var pgn = $('body').attr('id');

/*		Utils		*/

	function isMobile()
	{
		if($('html').hasClass('mobile')==true)	{ return true; } 
		else									{ return false; }
	}
	function isTablet()
	{
		if($('html').hasClass('tablet')==true)	{ return true; } 
		else									{ return false; }
	}
		
	function resizeSlides()
	{
        var slW = $('ul.slides').width(), slH = $('ul.slides').height();
		$('.slides li , .slides li img').css('width',slW+"px").css('height',slH+"px"); 
	}	
/*		Home		*/

	if(pgn=='page-')
	{
	
		var loader = new PxLoader();
		$('.slides li img').each(function( index ) {
			loader.addImage($( this ).attr('src'));
		});	
        resizeSlides();
		// callback that will be run once images are ready 
		loader.addCompletionListener(function() { 
			var px = new TimelineMax(); 
			px.to("#slide1",1,{ opacity:1 })
			  .call(homeSlideStart)
			  .set('.slides',{ css:{className:"+=active",backgroundImage:"none"} } )
			;
		}); 
		// begin downloading images 
		loader.start(); 
    }
		function homeSlide()
		{
			updateSlidePointer();
			TweenLite.defaultEase = Power3.easeInOut;
			if(sDir=='L') { var slideXp=100; } else if(sDir=='R') { var slideXp=-100; }
			var tl = new TimelineMax(), nwSsrc = $('#slide'+sP+' img').attr('src');
			tl		
				.call(homeSlideDisable)
				.set('#slide'+pP, 		{ zIndex:0 } )
				.set('#slide'+sP, 		{ xPercent:slideXp, zIndex:1 } )
				. to('#slide'+sP, sDur,	{ xPercent:0, force3D:true, display:'block', opacity:1, useFrames:true } )
				.set('.slides', 		{ backgroundImage:'url('+nwSsrc+')' } )			
				.set('.slides li', 		{ display:'block', opacity:0 } )
				.call(homeSlideEnable)
			;
		}
		function updateSlidePointer()
		{
			pP = sP;
			if(sDir=='L') { sP--; } else if(sDir=='R') { sP++; }
			if(sP>$('.slides li').length)	{ sP = 1; }
			if(sP==0)						{ sP = $('.slides li').length; }
		}	
		function homeSlideStart()
		{
			slideRun = setInterval(homeSlide, slideDelay*1000);
		}
		function homeSlideStop()
		{
			if(typeof(slideRun)==undefined) { } else { clearInterval(slideRun); }
		}

		function igWidget()
		{
			var igAI = '367274687', 
				//igCI = '2fcd7d0f304f45d88591ba2426d80254',
				igCI = '5e7498f390fb4e55a5c2197b6e3dce4c', 
				targetDIV = $('#morphewInstagram')
			;
			$.ajax({
				url: 'https://api.instagram.com/v1/users/'+igAI+'/media/recent/?client_id='+igCI,
				dataType: 'jsonp',
				success: function(ig){
					targetDIV.html(
              			'<h1>'+
              				'<a href="//instagram.com/'+ig.data[0].user.username+'" target="_blank">'+
              					'FOLLOW '+ig.data[0].user.full_name+' ON INSTAGRAM'+
              				'</a>'+
             			'</h1>'
              		);
                    for (i = 0; i < 6; i++) { 
						var igImg = ig.data[i].images.low_resolution, igURL = ig.data[i].link;
						targetDIV.append(
							'<a href="'+igURL+'" target="_blank">'+
								'<img class="ig" id="ig'+i+'" src = "'+igImg.url+'">'+
							'</a>'
						);
                    }                  
				}
            });
		}	
		igWidget();

	function homeSlideDisable()
	{
		$('#slidesRow #arwL, #slidesRow #arwR').off('click');
	}
	function homeSlideEnable()
	{
		$('#slidesRow #arwL, #slidesRow #arwR').on('click',function(){
			homeSlideStop();
			var arw = $(this).attr('id');
			sDir = arw.substring(3,4)
			homeSlide();
		});
	}



/*		About Us		*/	
//console.log(pgn);

		function prepYouTubePlayer(vid,aP)
		{
			if(isMobile()==true || isTablet()==true)
			{
				var iframeHeight = $('#ytPlayer').height();
				var iframeWidth = $('#ytPlayer').width();
				$('#ytPlayer').html('<iframe width="'+iframeWidth+'" height="'+iframeHeight+'" src="//www.youtube.com/embed/'+vid+'?autoplay='+aP+'&rel=0&controls=1&showinfo=0&related=0&playsinline=0&wmode=transparent&enablejsapi=1" frameborder="0" allowfullscreen></iframe></li>');
			}
			else
			{
				if(YT != undefined && YT.Player != undefined)
				{
					ytPlayer = new YT.Player('ytPlayer', {
						videoId: vid
						,playerVars: { 
							'wmode':'transparent', 						
							'autoplay': aP,
							'showinfo': 0,
							'controls': 1,
							'autohide':1,
							'loop':'0',
							'rel':0
						}
						,height: '100%'
						,width: '100%'
					});
				}
				else
				{
					setTimeout(prepYouTubePlayer, 500);
				}
			}
		}
	
      function quoteSlide()
		{
			updateQuotePointer();
			TweenLite.defaultEase = Power3.easeInOut;
			if(qDir=='L') { var slideXp=100; } else if(qDir=='R') { var slideXp=-100; }
			var tl = new TimelineMax(), nwSsrc = $('#quote'+sP+' img').attr('src');
			tl		
				.call(quoteSlideDisable)
				.set('#quote'+qP, 		{ xPercent:slideXp, zIndex:1 } )
				. to('#quote'+qP, sDur,	{ xPercent:0, force3D:true, display:'block', opacity:1, useFrames:true } )
				.call(updateQuote)
				.set('.quotes li', 		{ display:'block', opacity:0 } )
				.call(quoteSlideEnable)
			;
		}
		function updateQuotePointer()
		{
			if(qDir=='L') { qP--; } else if(qDir=='R') { qP++; }
			if(qP>$('.quotes li').length)	{ qP = 1; }
			if(qP==0)						{ qP = $('.quotes li').length; }
		}	
		function updateQuote()
		{
			var quot = $('#quote'+qP).html();
			$('.quote').html('<li>'+quot+'</li>');
		}	
		function quoteSlideStart()
		{
			updateQuote();
			quoteRun = setInterval(quoteSlide, quoteDelay*1000);
		}
		function quoteSlideStop()
		{
			if(typeof(quoteRun)==undefined) { } else { clearInterval(quoteRun); }
		}
		
		quoteSlideStart();

	function quoteSlideDisable()
	{
		$('#quoteGallery #arwL, #quoteGallery #arwR').off('click');
	}
	function quoteSlideEnable()
	{
		$('#quoteGallery #arwL, #quoteGallery #arwR').on('click',function(){
			quoteSlideStop();
			var arw = $(this).attr('id');
			qDir = arw.substring(3,4)
			quoteSlide();
		});
	}


  
/*		UI		*/	
	
	function initUI()
	{
		$('#product #ytPlayer').off('click');
		$('#product #ytPlayer').on('click',function(){
			var vid = $(this).data('vid');
			prepYouTubePlayer(vid,1);
		});
		
		$('#product .featured img#featImg').off('mouseover');
		$('#product .featured img#featImg').on('mouseover',function(){
			$(this).elevateZoom();
		});
		
		$('#product .thumbs .image a').off('click');
		$('#product .thumbs .image a').on('click',function(){
          	var imgURL = $(this).attr('href'),
          	featImg = $('#product .image.featured img#featImg');
		    $('.zoomContainer').remove();
		    featImg.removeData('elevateZoom');
		    featImg.attr('src', imgURL);
		    featImg.data('zoom-image', imgURL);
		    featImg.elevateZoom();
			return false;
		});
		
		$('img#videoImage').off('click');
		$('img#videoImage').on('click',function(){
			var vAUh = $(this).height();
			$(this).parent().height(vAUh);
			$(this).remove();
			prepYouTubePlayer('1qMtzSPK_Q8',1);
		});
		
		$('#footerNav.third a[title="Blog"]').attr('target','_blank');
		$('nav.main li a[href="/blogs/news"]').attr('target','_blank').attr('href','http://paradoxdesignsnyc.tumblr.com/');
      
		$('footer #blogPost.third h4').off('click');
		$('footer #blogPost.third h4').on('click',function(){
			var url = $('#footerNav.third a[title="About Us"]').attr('href');
            location.href = url;
		});
      
      
		homeSlideEnable();
		
		quoteSlideEnable();
	}
	initUI();

	$(window).on('blur',function(){
		homeSlideStop();
		quoteSlideStop();
	});

	$(window).on('resize',function(){
		resizeSlides();
	});
});